import { render } from "./Agent.vue?vue&type=template&id=6648be3b&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"

import "./Agent.vue?vue&type=style&index=0&id=6648be3b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6648be3b"]])

export default __exports__